const normalizeHotspots = (hotspotImage, hotspots) => {
  const { width, height } = hotspotImage

  return hotspots.map(hotspot => {
    const { posX, posY } = hotspot
    const normX = (posX / width) * 100
    const normY = (posY / height) * 100

    return {
      ...hotspot,
      posX: normX,
      posY: normY
    }
  })
}

export default normalizeHotspots



// WEBPACK FOOTER //
// ./src/utils/normalizeHotspots.js